var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('c-loader',{staticClass:"m-2",attrs:{"loader":_vm.isLoading}}):_vm._e(),_c('iframe',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}],staticClass:"custom-iframe",attrs:{"src":_vm.url},on:{"load":_vm.onIframeLoadedHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }